import css from './CartInputTable.css'
import { on, ready, query, queryAll } from '../../lib/dom.js'
import { stopRKey, fireEvent } from '../../lib/jsfunc.js'
import * as cart from '../../lib/cart.js'

ready(function () {
  document.onkeypress = stopRKey;
  if(!query('.CartInputTable')) return false;

  var inputs = queryAll('.CartInputTable td.anzahl input');
  for (var i=0;i<inputs.length;++i){
    if(cart.checkInputCart(inputs[i])){
      cart.setMindestmengeCart(inputs[i]);
    }
  }
})

on('change', '.CartInputTable td.anzahl input', function(event){
  event.preventDefault();

  var table = event.target.closest('table');
  var sendrequest = table.getAttribute('data-sendrequest');
  var inrequest = table.getAttribute('data-inrequest');

  if(sendrequest){
    table.setAttribute('data-inrequest', true);
    table.setAttribute('data-sendrequest', false);

    cart.checkInputMindestmenge(event.target);

    table.setAttribute('data-inrequest', false);
    table.setAttribute('data-sendrequest', true);
  }
})

on('keyup', '.CartInputTable td.anzahl input', function(event){
  fireEvent(event.target, 'change');
})
